<div class="row form" *ngIf="book != null">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle grupo</h4>
        </div>
        <div class="col-sm-8 form__head__boxBtn">
          <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()"><i
              class="fas fa-arrow-left m-r-5"></i> Regresar
          </button>
          <button class="btn btn-sm btn-danger" *ngIf="book.is_confirmed == false" (click)="delete(book)"><i
              class="fas fa-trash-alt m-r-2"></i>Borrar</button>
          <button type="button" class="btn btn-light btn-sm" (click)="printer()">
            <i class="fas fa-print m-r-5"></i> Imprimir
          </button>
          <a type="button" class="btn btn-info text-white btn-sm" *ngIf="book.is_confirmed == true"
            (click)="resetStatus()">
            <i class="fas fa-undo m-r-2"></i> Resetear estado
          </a>
          <button type="button" class="btn btn-success m-r-5" *ngIf="book.is_confirmed == false" (click)="confirm()">
            <i class="fas fa-check m-r-5"></i> CONFIRMAR SALIDA
          </button>
          <button class="btn btn-sm btn-primary" *ngIf="book.is_confirmed == false" (click)="edit(book.id)"><i
              class="fas fa-pen-alt m-r-2"></i>Editar
          </button>
        </div>
      </div> <!-- end row -->
    </div>
  </div>
  <div class="col-lg-12" id="body">
    <div class="card m-b-20" [ngClass]="{'border-schedule-private': book.typevehicle_tour == vehicle_private }">
      <div class="card-body p-l-5 p-r-5 p-t-5 p-b-0 faq-box boder-left-{{book.status_group.class}}">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div id="test" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left bold">Destino</div>
                <div class="child-right bold">
                  {{book.tour_data.description}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Estado</div>
                <div class="child-right">
                  <span class="badge f-s-12 badge-{{book.status_group.class}}">{{book.status_group.message}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código</div>
                <div class="child-right">
                  <span class="bold color-link">{{book.code}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Fecha de salida</div>
                <div class="child-right">
                  {{book.date_departure}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Guía de viaje</div>
                <div class="child-right">
                  {{book.guide_data.fullname}} - CEL: {{book.guide_data.cellphone}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Transporte</div>
                <div class="child-right">
                  {{book.transport_data.owner}} - CEL: {{book.transport_data.cellphone}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Capacidad Transporte</div>
                <div class="child-right">
                  {{book.transport_data.capacity}} - placa:
                  <span>{{book.transport_data.license_plate}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Pasajeros</div>
                <div class="child-right bold">
                  {{book.capacity_selected}} <span class="m-l-5">seleccionados</span>
                  <ng-container *ngIf="book.typevehicle_tour == vehicle_private">
                    <span class="m-l-10">
                      <span class="badge badge-orange badge-schedule-private f-s-10"><i
                          class="fas fa-bolt m-r-5"></i>Servicio Privado</span>
                    </span>
                  </ng-container>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Observaciones</div>
                <div class="child-right">
                  <span>{{book.observations}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">R.Usuario</div>
                <div class="child-right">
                  <span class="text-uppercase">{{book.user_data.username}} </span>
                  <ng-container *ngIf="book.user_updated_id != null">
                    <span class="m-l-10 f-s-10">(última actualización usuario: {{book.user_updated_data.username}}
                      {{book.updated_at | date: 'short'}} )</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-sm mb-0">
          <thead class="thead-default">
            <tr>
              <th class="text-center">N° PAX</th>
              <th>Responsable y Código</th>
              <th class="text-center">Etiqueta</th>
              <th>Hotel / Ubicacion</th>
              <th>Teléfonos</th>
              <th>Observaciones</th>
              <th>Deuda</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="bookings.length > 0">
              <ng-container *ngFor="let item of bookings">
                <tr [ngClass]="{'text-danger': book.date_departure != item.date_assigned }">
                  <td class="text-center f-s-13">
                    {{item.quantity}}
                  </td>
                  <td class="f-s-13">
                    {{item.client}}
                    <p class="f-s-10 bold m-b-0" *ngIf="item.is_received"><span
                        class="badge badge-success">Recibido</span> | {{item.agency_reponsible}}</p>
                    <p class="m-b-2" (click)="detailBookingExtends(item)" data-toggle="modal"
                      data-target="#openBookingsExtends">
                      <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite f-s-14"></i>
                      <span class=" f-s-11 bold pointer book__code">{{item.code}}</span>
                    </p>
                    <div class="d-inline-block" *ngIf="item.is_reference_pax">
                      REF:
                      <span>Niños ({{item.nro_pax_childs}})</span>,
                      <span>Adultos({{item.nro_pax_adults}})</span>,
                      <span>Ancianos ({{item.nro_pax_olds}})</span>
                    </div>
                  </td>
                  <td class="text-center">{{item.reference_voucher}}</td>
                  <td class="f-s-13">{{item.reference_location}}</td>
                  <td class="f-s-13">
                    <div>{{item.tel_1}}</div>
                    <div *ngIf="item.tel_2 != null">
                      {{item.tel_2}}
                    </div>
                  </td>
                  <td>
                    {{item.observations}}
                    <div *ngIf="item.observation != null">
                      | <span class="bold">{{item.observation}}</span>
                    </div>
                  </td>
                  <td class="f-s-13">
                    <ng-container *ngIf="!item.is_received">
                      {{toolsService.momeySol()}}{{(item.total - item.total_paid).toFixed(2)}}
                    </ng-container>
                    <ng-container *ngIf="item.is_received">
                      <ng-container *ngIf="item.is_control_total_received">
                        {{toolsService.momeySol()}}{{item.total - item.total_paid}}
                      </ng-container>
                      <ng-container *ngIf="!item.is_control_total_received">
                        {{toolsService.momeySol()}}{{item.assigned_payment}}
                      </ng-container>
                    </ng-container>
                    <!-- {{item.total - item.total_paid | currency:'S/ '}} -->
                  </td>
                </tr>
                <tr *ngIf="book.date_departure != item.date_assigned">
                  <td style="padding-top: 0px !important;" colspan="7"><span class="badge badge-danger f-s-12 w-100"><i class="fas fa-exclamation-triangle m-r-5"></i>
                      <span class="bold">ERROR CRÍTICO:</span> La reserva <strong>{{item.code}}</strong> se encuentra asignada con fecha <span
                        class="bold">{{item.date_assigned}}</span>, por lo que no puede estar asocioda a este grupo
                      (verificar en reservas)</span>
                    </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12">
      <p class="m-b-5">
        <i class="fas fa-star m-r-2 color-favorite f-s-14"></i> Se consideran reservas importantes (Referencia de un
        trato especial)
      </p>
    </div>
  </div>
  <div class="col-12 m-t-20">
    <button type="button" class="btn btn-light waves-effect waves-light" (click)="getAuditing()">
      Registro Auditoría <i class="far fa-clock m-l-5"></i>
    </button>
  </div>
  <!-- <ng-container *ngIf="filteredAuditsBooking.length > 0">
    <div class="col-12 m-t-20">
      <button type="button" class="btn btn-light waves-effect waves-light" data-toggle="modal"
        data-target="#myModal">
        Registro Auditoría <i class="far fa-clock m-l-5"></i>
      </button>
    </div>
  </ng-container> -->
   <div id="myModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0" id="myModalLabel">Registro auditoría cambios | Grupo <span class="bold">{{book.code}}</span></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="max-height: 500px;overflow-y: auto;">
          <div class="table-responsive">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Fecha y Hora</th>
                  <th>Usuario</th>
                  <th>Evento</th>
                  <th>Alias</th>
                  <th class="text-center">Detalles</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let audit of filteredAuditsBooking; let i = index">
                  <tr>
                    <td>{{ audit.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td>{{ audit.user || 'Desconocido' }}</td>
                    <td>{{ audit.event }}</td>
                    <td>
                      {{ audit.alias }}
                      <ng-container *ngIf="audit.model === 'GroupDetail'">
                        <p class="m-t-2 m-b-0 f-s-10"><span class="bold">Reserva</span>: {{ audit.item_name }}</p>
                      </ng-container>
                    </td>

                    <!-- <td>{{ audit.device_name }}</td> -->
                    <td class="text-center">
                      <button class="btn btn-sm f-s-10" [ngClass]="expandedIndex === i ? 'btn-dark' : 'btn-info'"
                        (click)="toggleDetails(i, audit)">
                        {{ expandedIndex === i ? 'Ocultar' : 'Ver detalles' }}
                        <ng-container *ngIf="expandedIndex === i">
                          <i class="fas fa-arrow-up"></i>
                        </ng-container>
                        <ng-container *ngIf="expandedIndex !== i">
                          <i class="fas fa-arrow-down"></i>
                        </ng-container>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="expandedIndex === i">
                    <td colspan="6" style="padding: 0px !important;">
                      <div class="card m-b-5" style="background: #fffbfb;">
                        <div class="card-body p-l-10 p-r-10 p-t-5 p-b-5">
                          <h5 class="m-t-10 f-s-15 text-underline">Detalles de la Auditoría</h5>
                          <ul>
                            <li><strong>Usuario:</strong> {{ selectedAudit?.user }}</li>
                            <li><strong>Acción:</strong> {{ selectedAudit?.event }}</li>
                            <li><strong>Fecha:</strong> {{ selectedAudit?.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                            </li>
                            <ng-container *ngIf="selectedAudit?.model === 'GroupDetail'">
                              <li><strong>Reserva:</strong> {{ selectedAudit?.item_name }}</li>
                            </ng-container>
                          </ul>
                          <h6 style="color: red;">Valores Anteriores</h6>
                          <ul>
                            <li *ngFor="let key of objectKeys(selectedAudit?.old_values)">
                              <strong>{{ key }}:</strong> {{ selectedAudit?.old_values[key] }}
                            </li>
                          </ul>
                          <h6 style="color: green;">Valores Nuevos</h6>
                          <ul>
                            <li *ngFor="let key of objectKeys(selectedAudit?.new_values)">
                              <strong>{{ key }}:</strong> {{ selectedAudit?.new_values[key] }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-bookings-extends (onSubmitEvent)="afterBookingDetail($event)"></app-bookings-extends>
